import React, { Component } from 'react';

import { MOBILE_WIDTH } from '../../constants';

export default function withSize(WrappedComponent) {
  class WithSize extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isMobile: false,
      };

      this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
    }

    componentWillMount() {
      window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentDidMount() {
      this.handleWindowSizeChange();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange() {
      this.setState(() => ({ isMobile: window.innerWidth <= MOBILE_WIDTH }));
    }

    render() {
      return (
        <WrappedComponent {...this.props} {...this.state} />
      );
    }
  }

  WithSize.displayName = `withSize(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithSize;
}



// WEBPACK FOOTER //
// ./src/components/WithSize/WithSize.js